<template>
    <div>
        <h2>All Users</h2>
        <table>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Username</th>
                    <th>Role</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" v-bind:key="user.id">
                    <td>{{user.userId}}</td>
                    <td>{{user.username}}</td>
                    <td>{{user.role}}</td>
                    <td><button class="button" v-on:click="viewUserReviews(user.userId)" v-show="user.role==='user'">View User's Reviews</button></td>
                </tr>
            </tbody>
        </table>
    </div>
  </template>

<script>
export default {
  name: "get-users",
  data() {
    return {
    };
  },
  methods: {
        viewUserReviews(userId){
            this.$router.push(`/user/${userId}`)
        }
    },
    computed: {
        users () {
            return this.$store.getters.getAllUSers;
        }
    }

};
</script>

<style>

</style>